// Libraries
import I18n from 'i18next'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { message, Modal } from 'antd'
import { get, includes, defaultTo, isNil } from 'lodash'

// Ressources
import { actions as cleaningConditionActions } from 'Resources/CleaningConditionsResource'

// Common components
import { ManageModal } from 'Components'

// Specs
import { ModalSpecs } from './Specs'

// Ãcrans
import { List } from './Screens'
import { formatOrderedData } from 'Helpers'

const { confirm } = Modal

class CleaningConditionConstructor extends Component {
  static propTypes = {
    // Actions d'API
    actions: PropTypes.object,

    // DonnÃ©es de la vue
    condition: PropTypes.object,
    conditions: PropTypes.array,

    // TÃ©moin d'activitÃ© API
    isGathering: PropTypes.bool,
    isUpdating: PropTypes.bool,
    isCreating: PropTypes.bool,

    // Navigation interne
    navigation: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
      getParam: PropTypes.func.isRequired,
      setParams: PropTypes.func.isRequired
    })
  }

  static defaultProps = {
    // Actions d'API
    actions: {},

    // DonnÃ©es de la vue
    condition: {},
    conditions: [],

    // TÃ©moin d'activitÃ© API
    isGathering: false,
    isUpdating: false,
    isCreating: false
  }

  constructor(props) {
    super(props)

    this.state = {
      openedModal: null
    }
  }

  componentDidMount = () => {
    // RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
    this.fetchConditionsData()

    if (this.getContext() === 'single') {
      this.getConditionData().then(this.askUpdateCondition)
    }
  }

  /**
   * RÃ©cupÃ©ration du contexte actuel du constructeur de page
   */
  getContext = () => {
    return isNil(this.props.navigation.getParam('id')) ? 'list' : 'single'
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
   */
  fetchConditionsData = () => {
    this.props.actions.fetchCleaningConditions().catch(() => {
      message.error(I18n.t('api.errors.condition.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es dÃ©taillÃ©es d'un Ã©lÃ©ment de la vue
   */
  getConditionData = (condition = this.props.navigation.getParam('id')) =>
    new Promise((resolve, reject) => {
      this.props.actions
        .getCleaningCondition(condition)
        .then(response => {
          // DÃ©tails rÃ©cupÃ©rÃ©s
          resolve(get(response, 'body'), response)
        })
        .catch(error => {
          // Erreur lors du refresh
          reject(error)
          message.error(I18n.t('api.errors.condition.get'))
        })
    })

  /**
   * Actions groupÃ©es:
   * Archivage de plusieurs lignes du tableau
   */
  archiveManyCondition = (condition, clearTableSelections) => {
    this.props.actions
      .archiveManyCleaningCondition(condition)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.condition.bulk.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.condition.bulk.archive'))
      })
  }

  /**
   * Archivage d'une ligne du tableau
   */
  archiveCondition = condition => {
    this.props.actions
      .archiveCleaningCondition(condition)
      .then(() => {
        this.safelyCloseModal()
        this.props.navigation.setParams({ id: null })
        message.success(I18n.t('api.success.condition.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.condition.archive'))
      })
  }

  /**
   * Actions groupÃ©es:
   * Suppression de plusieurs lignes du tableau
   */
  deleteManyCondition = (condition, clearTableSelections) => {
    this.props.actions
      .archiveCleaningConditions(condition)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.condition.bulk.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.condition.bulk.delete'))
      })
  }

  /**
   * Suppression d'une ligne du tableau
   */
  deleteCondition = condition => {
    this.props.actions
      .archiveCleaningCondition(condition)
      .then(() => {
        this.safelyCloseModal()
        this.props.navigation.setParams({ id: null })
        message.success(I18n.t('api.success.condition.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.condition.delete'))
      })
  }

  /**
   * Mise Ã  jour d'un equipement
   */
  updateCondition = (updatedCondition, originalCondition) =>
    new Promise((resolve, reject) => {
      this.props.actions
        .updateCleaningCondition({
          id: get(originalCondition, 'id'),
          ...updatedCondition
        })
        .then(response => {
          this.safelyCloseModal()
          this.fetchConditionsData()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.condition.update'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.condition.update'))
        })
    })

  /**
   * CrÃ©ation d'une condition
   */
  createCondition = createdCondition =>
    new Promise((resolve, reject) => {
      this.props.actions
        .createCleaningCondition(createdCondition)
        .then(response => {
          this.safelyCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.condition.create'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.condition.create'))
        })
    })

  /**
   * Actions groupÃ©es:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askArchiveManyConditions = (...params) => {
    confirm({
      title: I18n.t('pages.condition.modal.archive.multiple.title'),
      content: I18n.t('pages.condition.modal.archive.multiple.content'),
      okText: I18n.t('pages.condition.modal.archive.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.condition.modal.archive.multiple.cancelText'),
      onOk: () => {
        this.archiveCondition(...params)
      },
      maskClosable: true
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askArchiveCondition = () => {
    const { condition } = this.props

    confirm({
      title: I18n.t('pages.condition.modal.archive.single.title'),
      content: I18n.t('pages.condition.modal.archive.single.content'),
      okText: I18n.t('pages.condition.modal.archive.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.condition.modal.archive.single.cancelText'),
      onOk: () => {
        this.archiveCondition(condition)
      },
      maskClosable: true
    })
  }

  /**
   * Actions groupÃ©es:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askDeleteManyConditions = (...params) => {
    confirm({
      title: I18n.t('pages.condition.modal.delete.multiple.title'),
      content: I18n.t('pages.condition.modal.delete.multiple.content'),
      okText: I18n.t('pages.condition.modal.delete.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.condition.modal.delete.multiple.cancelText'),
      onOk: () => {
        this.deleteManyCondition(...params)
      },
      maskClosable: true
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askDeleteCondition = () => {
    const { condition } = this.props

    confirm({
      title: I18n.t('pages.condition.modal.delete.single.title'),
      content: I18n.t('pages.condition.modal.delete.single.content'),
      okText: I18n.t('pages.condition.modal.delete.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.condition.modal.delete.single.cancelText'),
      onOk: () => {
        this.deleteCondition(condition)
      },
      maskClosable: true
    })
  }

  /**
   * Demande de modification d'une ligne du tableau
   */
  askUpdateCondition = () => {
    this.setState({ openedModal: 'updateCondition' })
  }

  /**
   * Demande de crÃ©ation d'une ligne du tableau
   */
  askCreateCondition = () => {
    this.setState({ openedModal: 'createCondition' })
  }

  /**
   * Fermeture de toutes les modales
   */
  safelyCloseModal = () => {
    const { openedModal } = this.state

    if (openedModal === 'updateConclusion') {
      this.setState({ openedModal: 'transition' }, () => {
        setTimeout(
          this.setState({ openedModal: null }, () => {
            this.props.navigation.setParams({ id: null })
          }),
          200
        )
      })
    } else {
      this.setState({ openedModal: null })
    }
  }

  /**
   * Callback:
   * CrÃ©ation d'une ligne de tableau rÃ©ussie
   */
  handleRowCreated = () => {
    this.safelyCloseModal()
  }

  /**
   * Callback:
   * Modification d'une ligne de tableau rÃ©ussie
   */
  handleRowUpdated = () => {
    this.safelyCloseModal()
  }

  /**
   * Clic sur une ligne du tableau
   */
  handleRowClick = condition => {
    // Navigation vers la page dÃ©taillÃ©e
    this.props.navigation.setParams({ id: get(condition, 'id') })

    this.getConditionData(condition)
      .then(() =>
        // Ouverture de la modale
        this.askUpdateCondition()
      )
      .catch(() => {
        this.props.navigation.setParams({ id: null })
      })
  }

  handleDraggedRowReleased = orderedData => {
    const formattedOrderedData = formatOrderedData(orderedData)

    this.props.actions
      .orderCleaningCondition(formattedOrderedData)
      .then(() => message.success(I18n.t('api.success.condition.order')))
      .catch(() => message.error(I18n.t('api.errors.condition.order')))
  }

  /**
   * Formatage des lignes de la modale de modification / crÃ©ation
   */
  formatModalRows = rows => {
    return rows
  }

  render() {
    // RÃ©cupÃ©ration des Ã©lÃ©ments des props
    let {
      isGathering,
      isUpdating,
      isCreating,
      conditions,
      condition
    } = this.props

    // RÃ©cupÃ©ration des Ã©lÃ©ments du state
    const { openedModal } = this.state

    // Chargement
    const loading = isGathering || isUpdating || isCreating

    // CrÃ©ation de la liste des fonctions constructeur exposÃ©s au Ã©crans
    const constructorFunctions = {
      // Clic sur un ligne de tableau
      handleRowClick: this.handleRowClick,

      // Gestion de la modale
      safelyCloseModal: this.safelyCloseModal,

      // RÃ©cupÃ©ration des donnÃ©es dÃ©taillÃ©es d'une ligne du tableau
      getConditionData: this.getConditionData,

      // CrÃ©ation d'une ligne de tableau
      handleRowCreated: this.handleRowCreated,
      askCreateCondition: this.askCreateCondition,

      // Modification d'une ou plusieurs ligne(s) de tableau
      handleRowUpdated: this.handleRowUpdated,
      askUpdateCondition: this.askUpdateCondition,
      askUpdateManyConditions: this.askUpdateCondition,

      handleDraggedRowReleased: this.handleDraggedRowReleased,

      // Archivage d'une ou plusieurs ligne(s) du tableau
      askArchiveCondition: this.askArchiveCondition,
      askArchiveManyConditions: this.askArchiveManyConditions,

      // Suppression d'une ou plusieurs ligne(s) du tableau
      askDeleteCondition: this.askDeleteCondition,
      askDeleteManyConditions: this.askDeleteManyConditions
    }

    // Ajout des actions sur la modale
    ModalSpecs.actions.delete.onClick = this.askDeleteCondition

    // Ajout des lignes au formulaire
    // formLayout = merge(formLayout, manageModal)

    return (
      <Fragment>
        {/* Rendu de l'Ã©cran appropriÃ© au contexte du constructeur */}
        <List
          loading={loading}
          constructorFunctions={constructorFunctions}
          constructorState={this.state}
          dataList={conditions}
        />

        {/* Ouverture de la modale de crÃ©ation / modification */}
        <ManageModal
          width={800}
          loading={loading}
          onCancel={this.safelyCloseModal}
          onOk={this.handleRowCreated}
          onChange={
            openedModal === 'updateCondition'
              ? this.updateCondition
              : this.createCondition
          }
          visible={includes(
            ['createCondition', 'updateCondition'],
            openedModal
          )}
          data={
            includes(['transition', 'updateCondition'], openedModal)
              ? condition
              : null
          }
          {...ModalSpecs}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(CleaningConditionConstructor, 'defaultProps', {})

  return {
    conditions: defaultTo(
      get(state, 'cleaningCondition.items'),
      defaultProps.conditions
    ),
    condition: defaultTo(
      get(state, 'cleaningCondition.item'),
      defaultProps.condition
    ),
    isGathering:
      defaultTo(
        get(state, 'cleaningCondition.isFetching'),
        defaultProps.isGathering
      ) ||
      defaultTo(
        get(state, 'cleaningCondition.isFetchingItem'),
        defaultProps.isGathering
      ),
    isUpdating: defaultTo(
      get(state, 'cleaningCondition.isUpdating'),
      defaultProps.isUpdating
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...cleaningConditionActions }, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CleaningConditionConstructor)
